/**
 * Responsive spacers.
 *
 * @package globus
 * @since   1.0.0
 */
import $ from 'jquery';

/**
 * Responsive spacers.
 *
 * @since 1.0.0
 */
function responsiveSpacers() {
	$('.wp-block-spacer').each(
		function () {
			const spacerHeight = $(this).height();
			const newSpacerHeight = (spacerHeight / 3);

			setTimeout(
				() => {
					if ($(window).width() < 768) {
						$(this).height(newSpacerHeight);
					} else {
						$(this).height(spacerHeight);
					}
				},
				500,
			);
		},
	);
}

window.addEventListener('DOMContentLoaded', responsiveSpacers);
